import { Alert, Box, Skeleton, Typography } from "@mui/material";
import { useNextProjectNumber } from "~api/projects";
import { useCurrentTenant } from "~contexts/CurrentTenantContext/CurrentTenantContext";
import { useTranslation } from "~contexts/I18nContext/I18nContext";

export function NextProjectNumber() {
  const currentTenant = useCurrentTenant();
  const {
    data: ProjectNumber,
    isError,
    isLoading,
  } = useNextProjectNumber(currentTenant.id);
  const t = useTranslation();

  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h4" component="h3" sx={{ marginBottom: 2 }}>
        {t.settingsNextAvailableProjectNumber}
      </Typography>

      {isLoading && <Skeleton width="100px" height="1.5rem" />}

      {!isLoading && !isError && ProjectNumber?.next_number && (
        <Typography component="p" sx={{ fontSize: "0.75rem", marginBottom: 2 }}>
          {ProjectNumber.next_number}
        </Typography>
      )}

      {isError && (
        <Alert severity="error" sx={{ marginBottom: 2 }}>
          {t.settingsErrorFetchingNextProjectNumber}
        </Alert>
      )}
    </Box>
  );
}
